import PropTypes from 'prop-types'
import { Component, ComponentClass, ComponentType, createElement } from 'react'
import { Omit } from 'type-zoo'

import { Context } from './provider'

// Injects props and removes them from the prop requirements.
// Will not pass through the injected props if they are passed in during
// render. Also adds new prop requirements from TNeedsProps.
export type InferableComponentEnhancerWithProps<TInjectedProps, TNeedsProps> = <P extends TInjectedProps>(
  component: Component<P>
) => ComponentClass<Omit<P, keyof TInjectedProps> & TNeedsProps> & {
  WrappedComponent: Component<P>
}

export function inject<TInjectedProps extends { [provider: string]: any }, TNeedsProps = {}>(
  mapper: (dependencies: TInjectedProps) => TInjectedProps
) {
  type InjectedWithOwnProps = TNeedsProps & TInjectedProps

  // tslint:disable-next-line:only-arrow-functions
  return function(Cmp: ComponentType<InjectedWithOwnProps>) {
    return class Injector extends Component<TNeedsProps> {
      static contextTypes = {
        injectables: PropTypes.object,
      }

      static WrappedComponent = Cmp

      static displayName = `Injector(${getDisplayName(Cmp)})`

      // @ts-ignore
      context: Context
      render() {
        const injectables = mapper(this.context.injectables as TInjectedProps)
        const props: InjectedWithOwnProps = { ...(this.props as any), ...(injectables as any) }

        return createElement(Cmp, props)
      }
    }
  }
}

function getDisplayName(component: ComponentType<any>): string {
  return component.displayName || component.name || 'Component'
}



// WEBPACK FOOTER //
// ./src/modules/di/inject.tsx